/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 17:28 2022-01-20
 */

import * as Vue from 'vue-tsx-support';
import { Component } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import _ from 'lodash';
import { createBEM } from 'src/util/bem';
import './stateParams.less';
import Bus, { Events } from 'src/util/bus';
import { StationListDOI } from 'src/pages/stationList/api/stationListApi';
import StationDetailApi from '../api/stationDetailApi';
import enumDivisorParams from 'src/enums/enumDivisorParams';
import EnumDivisorParams from 'src/enums/enumDivisorParams';
import EnumWorkStatus from 'src/enums/enumWorkStatus';
let bem = createBEM('state-params');

@Component
export default class StateParams extends Vue.Component<any> {
    mn: string = '';
    id: number = 0;
    runMode: string = ''
    instrumentList: { divisorCode: string; divisorName; status: string; params: { name: string; value: string }[] }[] = [];
    currentDivisor: { divisorCode: string; divisorName; status: string; params: { name: string; value: string }[] } = {
        divisorCode: '',
        divisorName: '',
        status: '',
        params: [],
    };
    sysParams: { name: string; value: string }[] = [];
    deviceType: Number = 0;

    async search() {
        let [params, status] = await Promise.all([this.searchKeyParams(), this.searchKeyStatus()]);
        params = params.filter(i => !i.divisorName.includes("浊度") && !i.divisorName.includes("电导率")
            && !i.divisorName.includes("溶解氧") && !i.divisorName.includes("温度") && !i.divisorName.includes("pH"))
        params.map(element => {
            element.status = EnumWorkStatus.findId(+(status[element.divisorCode] || {})['i12001-Info']).getName();
        });
        this.instrumentList = Object.freeze(params);
        this.currentDivisor = this.instrumentList[0];
    }

    async searchSys() {
        this.searchSysParams();
        this.searchSysStatus();
    }
    async searchSysParams() {
        let { code, data } = await StationDetailApi.searchSysParams(this.mn, this.id);
        if (code === 0) {
            this.sysParams = data;
        }
    }
    async searchSysStatus() {
        let { code, data } = await StationDetailApi.searchSysStatus(this.mn);
        if (code === 0) {
            let map = {
                '1': '周期模式',
                '2': '定点模式',
                '3': '应急模式',
                '4': '维护模式',
            };
            if(data && data.RunMode) {
                this.runMode = map[data.RunMode]
            }
        }
    }
    async searchKeyParams() {
        let { code, data } = await StationDetailApi.searchKeyParams(this.mn, this.id);
        if (code === 0) {
            return data.header.map(i => ({
                divisorCode: i.key,
                divisorName: i.component_name,
                status: '',
                params: Object.entries(data.data_info[i.key] || {}).map(i => ({
                    name: EnumDivisorParams.findCode(i[0]).getName()||i[0],
                    value: i[1],
                })),
            }));
        } else {
            return [];
        }
    }
    async searchKeyStatus() {
        let { code, data } = await StationDetailApi.searchKeyStatus(this.mn, this.id);
        if (code === 0) {
            return data.data_info;
        } else {
            return {};
        }
    }

    created() {
        this.deviceType = parseInt(this.$route.query.type);
    }

    mounted() {
        this.mn = this.$route.query.mn;
        this.id = +this.$route.query.id;
        this.search();
        this.searchSys();
        Bus.$on(Events.StationChange, this.stationChange);
    }
    stationChange(data: StationListDOI.RowDataI) {
        this.mn = data.mn;
        this.id = data.id;
        this.search();
        this.searchSys();
    }

    beforeDestroy() {
        Bus.$off(Events.StationChange, this.stationChange);
    }

    clickDivisor(data) {
        this.currentDivisor = data;
    }
    render(h) {
        return (
            <div class={bem()}>
                <div class={bem('title')}>系统参数</div>
                <div class={bem('title')}>
                    参数状态：<span style="color: #02fb71">{this.runMode}</span>
                </div>
                <div class={bem('system')}>
                    <div class={bem('system-line')}>
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                    </div>
                    {this.sysParams.map(i => {
                        return [
                            <div class={bem('system-param-name')}>{i.name}</div>,
                            <div class={bem('system-param-value')}>{i.value}</div>,
                        ];
                    })}
                </div>
                <div class={bem('title')} v-if={this.deviceType != 2}>
                    分析仪参数
                    {this.instrumentList.map(i => (
                        <div
                            class={bem('params-btn', { acitve: this.currentDivisor.divisorCode === i.divisorCode })}
                            onClick={this.clickDivisor.bind(this, i)}
                        >
                            {i.divisorName}
                        </div>
                    ))}
                </div>
                <div class={bem('title')} v-if={this.deviceType != 2}>
                    分析仪状态：<span style="color: #02fb71">{this.currentDivisor.status}</span>
                </div>
                <div class={bem('system')} v-if={this.deviceType != 2}>
                    <div class={bem('system-line')}>
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                    </div>
                    {this.currentDivisor.params.map(i => {
                        return [
                            <div class={bem('system-param-name')}>{i.name}</div>,
                            <div class={bem('system-param-value')}>{i.value}</div>,
                        ];
                    })}
                </div>
            </div>
        );
    }
}
